module.exports = __webpack_public_path__ + "static/media/liyushan_web.9abfeac9.png";